import { createFileRoute } from '@tanstack/react-router';
export const Route = createFileRoute('/_staff/accesses/_layout/settings/')({});